import script from "./Custom_DDL_Checkbox.vue?vue&type=script&setup=true&lang=js"
export * from "./Custom_DDL_Checkbox.vue?vue&type=script&setup=true&lang=js"

import "./Custom_DDL_Checkbox.vue?vue&type=style&index=0&id=8c83f3f4&lang=css"

const __exports__ = script;

export default __exports__